'use strict';

const gaTracker = require('../../analytics/gaTracker');
const $modal = $('#competitors-modal');
const $modalForm = $('#generation-bar-in-competitors-modal');
const $modalFormHidden = $('#url-to-generate');

function dashboardManageCompetitors () {
  $modal.on('show.bs.modal', function () {
    gaTracker('modal', 'click', 'modal-competitor-modal-open');
  });

  $modal.on('hide.bs.modal', function () {
    gaTracker('modal', 'click', 'modal-competitor-modal-close');
  });

  $modalForm.find('input').on('change keydown', function () {
    let $formGroup = $(this).parents('.form-group');
    $formGroup.removeClass('has-error');
  });

  $modalForm.find('.js-remove-competitor').on('click', function (e) {
    e.preventDefault();
    let $formGroup = $(this).parents('.form-group');
    let $input = $formGroup.find('input');
    $input.val('');
    $input.focus();
    $formGroup.removeClass('has-error');
  });

  $('.js-update-competitors').on('click', function (event) {
    event.preventDefault();
    modalLoading(true);
    let urlToGenerate = $('.js-generation-data').attr('data-regenerate-domain');
    let params = {
      'url': urlToGenerate,
      'competitors': []
    };

    $modalForm.find('input').each(function () {
      params.competitors.push(($(this).val().length > 0) ? $(this).val() : '');
    });

    $.ajax({
      type: 'POST',
      data: params,
      cache: false,
      url: $modalForm.attr('action')
    }).done(function (data) {
      if (data) {
        if (data.success) {
          $modalFormHidden.trigger('submit', ['url=' + params.url]);
        } else if (data.validation) {
          let resp = data.validation;
          for (let i = 0; i < resp.length; i++) {
            if (!resp[i].validCompetitor) {
              $('#competitor-' + (1 + i)).addClass('has-error');
            }
          }
          modalLoading(false);
        } else {
          modalLoading(false);
        }
      } else {
        window.Raven.captureMessage('Invalid competitor validation', {
          extra: {
            url: data
          }
        });
        modalLoading(false);
      }
    }).fail(function (jqXHR, textStatus, errorThrown) {
      modalLoading(false);
      window.Raven.captureMessage('Failed to update Competitors', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown
        }
      });
    });
  });
}

function modalLoading (action) {
  $modal.toggleClass('busy', action);
}

module.exports = dashboardManageCompetitors;
